module.exports = __webpack_public_path__ + "img/zoom-04.c7a50928.webp";